"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.BalanceSummary=void 0;const BalanceSummary=exports.BalanceSummary=_styledComponents.default.div`
display: block;
padding: 0px 16px 10px 16px;
align-items: center;
gap: 10px;
align-self: stretch;
background-color: #FFFFFF;

.inline{
    display: flex;
}

.activity{
  font-weight:600;
  font-size: 14px;
  margin-top: 12px;
}

span{
    font-size: 12px;
}

div{
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    color:#2A2928;
}

.currentBalance{
    margin-top: 9px;
    font-weight: 600;
}

p{
    margin-bottom: 2px;
}`;